// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const PhonePure = createIcon(`
  <svg xmlns="http://www.w3.org/2000/svg" width="112" height="123" viewBox="0 0 112 123">
    <g fill="none" fill-rule="evenodd">
        <g stroke="#00AEEF" stroke-width="3.6">
            <path d="M58.092 118.085L44.644 95.073M23.066 58.123L9.01 34.042M59.332 118.559c4.906-2.865 9.227-5.853 9.227-5.853L57.266 92.56s-6.916 3.417-12.62 2.514c-5.369-.852-11.99-10.524-15.147-15.931s-8.33-15.926-6.432-21.019c2.016-5.412 8.39-9.758 8.39-9.758L19.458 28.63s-4.725 2.294-9.63 5.162c-18.742 10.945.6 46.327 5.025 53.903 4.424 7.573 25.737 41.809 44.478 30.864z"/>
        </g>
        <path stroke="#00AEEF" stroke-width="3.6" d="M80.096 2.197c-16.5 0-29.875 10.742-29.875 23.992 0 3.389.885 6.613 2.467 9.537l-4.541 14.453 15.703-3.873c4.678 2.442 10.249 3.873 16.246 3.873 16.5 0 29.875-10.742 29.875-23.99 0-13.25-13.375-23.992-29.875-23.992z"/>
        <path fill="#00AEEF" d="M70 24a3 3 0 0 1 0 6 3 3 0 1 1 0-6zM80 24a3 3 0 0 1 0 6 3 3 0 1 1 0-6zM90 24a3 3 0 0 1 0 6 3 3 0 1 1 0-6z"/>
    </g>
  </svg>
`);

export const PhoneIcon: React.FC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <PhonePure className={props.iconClassName} />
);

PhoneIcon.displayName = 'PhoneIconIcon';
